import { getApiUrl, getCurrentLanguageId, displayError } from "./common";
import HttpClient from "./http-client";
import LoadingIndication from "./loading-indication";
import {saveAs} from 'file-saver'

export default class ProductDetailDownload {
    private downloadBtn: HTMLInputElement;
    private productId: number;

    constructor(downloadBtnId: string, productId: number) {
        this.initElements(downloadBtnId);
        this.productId = productId;
    }

    public init(): void {
        this.registerDownloadButtonListener();
    }

    private initElements(downloadBtnId: string): void {
        this.downloadBtn = <HTMLInputElement>document.getElementById(downloadBtnId);
    }

    private registerDownloadButtonListener(): void {
        this.downloadBtn.addEventListener("click", async () => {
            await this.downloadProductSheet().then(() => LoadingIndication.hide(this.getBaseElement()));
        });
    }

    private getApiUrl(): string {
        return `${getApiUrl()}/file/product-sheet`;
    }

    private getBaseElement(): HTMLElement {
        return document.querySelector('[data-component="ProductDetailDownload"]');
    }

    private async downloadProductSheet(): Promise<void>{
        LoadingIndication.show(this.getBaseElement());

        const url = `${this.getApiUrl()}/${this.productId}`;
        const languageId = getCurrentLanguageId();
        const response = await new HttpClient().fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Current-Language-Id': languageId
            },
        });

        if (response && response.ok) {
            await this.onSuccess(response).then(() => LoadingIndication.hide(this.getBaseElement()));
        } else {
            LoadingIndication.hide(this.getBaseElement());

            if (response.status == 404) {
                displayError('Product sheet for product was not found');
                return;
            }
            displayError('Unexpected error');
        }
    }

    private async onSuccess(response: Response): Promise<void> {
        const blob = await response.blob();
        saveAs(blob, 'ProductSheet_' + this.productId);
    }
}
